import script from "./SurveyBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyBanner.vue?vue&type=script&setup=true&lang=js"

import "./SurveyBanner.vue?vue&type=style&index=0&id=794eccce&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-794eccce"]])

export default __exports__